<footer class="footer-area">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/logo_new_white.png" style="max-height: 90px;" alt="logo"></a>
                    <p style="margin-top:-10px">
                        FabbricaFormazione.it è un polo di eccellenza nella formazione professionale, nato dall’esperienza e dalla competenza di TutorUp Srl, una realtà consolidata nel settore dell’istruzione e della preparazione accademica.
                    </p>
                    <a routerLink="/" class="logo"><img src="assets/img/tutor.png" style="max-height: 40px;" alt="logo"></a>
                    <ul class="social-link">
                        <li><a href="https://www.facebook.com/tutorup.it" class="d-block" target="_blank"><i class='bx bxl-facebook'></i></a></li>
                        <li><a href="https://www.instagram.com/tutorup.it/" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                    </ul>
                        <div class="row pt-3">
                            <div class="col-12 p-0" align="left">
                                <a href="https://apps.apple.com/it/app/discentya/id6468484981" target="_blank">
                                    <img src="assets/img/applestore-badge-white.png" style="width: 160px;">
                                    <img src="assets/img/googlestore-badge-white.png" class="ms-3" style="width: 160px;">
                                </a>
                            </div>
                        </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>LINK</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Home</a></li>
                        <li><a routerLink="/elenco-corsi">Elenco Corsi</a></li>
                        <li><a routerLink="/validita-attestati">Validità Attestato</a></li>
                        <li><a routerLink="/contatti">Contatti</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>LOGIN</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/">Menù</a></li>
                        <li><a href="#" target="_blank">Docenti/Tutor</a></li>
                        <li><a href="#" target="_blank">Partner</a></li>
                    </ul>
                </div>
            </div>
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>DOVE SIAMO</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>Viale II Melina, 4<br>80055 Portici (NA)</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+390813186006">Telefono: (+39) 081-3186006</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:info@tutorup.it">info@tutorup.it</a></li>
                        <li><i class='bx bxs-inbox'></i><a href="tel:+390813186006">Lunedì-Sabato<br>15:15 ÷ 19:30</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-8 col-md-8">
                    <p><i class='bx bx-copyright'></i>2025 TutorUP Srl - realizzato da <a target="_blank" href="https://www.discentya.it/">Discentya</a>, piattaforma per la formazione online</p>
                </div>
                <div class="col-lg-2 col-md-2">
                    <ul>
                        <li><a href="https://fabbricaformazione.it/privacy-policy-2/" target="_blank">Privacy Policy</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
</footer>
